import type { StylePropertiesTypes } from '@wix/document-services-types'
import { colorConverterMap } from '../Color/colorPropsToCss'
import { atomicStylePropsConverterMap } from '../../atomics/atomicPropsToCss'

/** Internal Maps */
const lineConverterMap = {
	Keyword: atomicStylePropsConverterMap.Keyword,
	Keywords: atomicStylePropsConverterMap.Keywords,
}

const thicknessConverterMap = {
	Length: atomicStylePropsConverterMap.Length,
	percentage: atomicStylePropsConverterMap.percentage,
	Keyword: atomicStylePropsConverterMap.Keyword,
}

/** Internal Converters */
const textDecorationConverter = (prop: StylePropertiesTypes.TextDecoration) => {
	const { color: colorProp, style: styleProp, line: lineProp, thickness: thicknessProp } = prop

	const color = colorProp && colorConverterMap[colorProp.type](colorProp)
	const style = styleProp && atomicStylePropsConverterMap.Keyword(styleProp)
	const line = lineProp && lineConverterMap[lineProp.type](lineProp)
	const thickness = thicknessProp && thicknessConverterMap[thicknessProp.type](thicknessProp)

	return {
		color,
		style,
		line,
		thickness,
		[prop.type]: `--var(--{propName}-line), --var(--{propName}-style), --var(--{propName}-color), --var(--{propName}-thickness)`,
	}
}

/** External Map */
export const textDecorationConverterMap = {
	TextDecoration: textDecorationConverter,
}
